import { BlackListScreenNavigationProps } from "./types"
import React from "react"
import BlackList from "./black-list-screen"
import { PageRoot } from "~screens/page-root"


const BlackListScreen: React.FC<BlackListScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <BlackList />
    </PageRoot>
  )
}

export default BlackListScreen
